export const SourcetreeMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.5918 29.7261C28.5918 27.1901 26.5358 25.1341 23.9998 25.1341C21.2248 25.1341 18.9748 22.8841 18.9748 20.1091C18.9748 17.3341 21.2248 15.0841 23.9998 15.0841C24.3408 15.0841 24.6728 15.1191 24.9948 15.1831V5.28114C24.6658 5.25914 24.3348 5.24414 23.9998 5.24414C15.7898 5.24414 9.13477 11.8991 9.13477 20.1091C9.13477 26.7151 13.4468 32.3071 19.4068 34.2431V41.7101C19.4068 42.2871 19.8748 42.7551 20.4518 42.7551H27.5458C28.1228 42.7551 28.5908 42.2871 28.5908 41.7101V29.7261H28.5918Z"
      fill="white"
    />
    <path
      d="M24 5.24512V15.0851C26.775 15.0851 29.025 17.3351 29.025 20.1101C29.025 22.8851 26.775 25.1351 24 25.1351C26.536 25.1351 28.592 27.1911 28.592 29.7271V34.2481C34.553 32.3131 38.865 26.7161 38.865 20.1101C38.865 11.9001 32.21 5.24512 24 5.24512Z"
      fill="url(#paint0_linear_818_470)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_470"
        x1="31.432"
        y1="31.5641"
        x2="31.432"
        y2="15.7691"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.4" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
